import React, { useEffect, useRef } from 'react';
import { AmbilightProvider, useAmbilightContext } from './context/AmbilightContext';
import { Header } from './components/Header/Header';
import { VirtualScreen } from './components/VirtualScreen/VirtualScreen';
import { SlimBottomBar } from './components/SlimBottomBar/SlimBottomBar';
import { PointConfigModal } from './components/LightNodes/PointConfigModal';
import { LightManagerModal } from './components/LightManager/LightManagerModal';
import { TunePopover } from './components/TunePopover/TunePopover';
import { animateAppEntrance } from './animations/gsapEffects';

const AmbilightStudio: React.FC = () => {
  const { masterColor } = useAmbilightContext();

  const headerRef = useRef<HTMLDivElement>(null);
  const screenContainerRef = useRef<HTMLDivElement>(null);
  const bottomBarRef = useRef<HTMLDivElement>(null);

  // GSAP: Entrada fluida de la aplicación
  useEffect(() => {
    animateAppEntrance(
      screenContainerRef.current,
      headerRef.current,
      bottomBarRef.current
    );
  }, []);

  return (
    <div className="relative w-full min-h-screen flex flex-col justify-between overflow-hidden bg-[#07090e] select-none">
      {/* Luz Ambiental de Fondo Cinematográfica */}
      {masterColor.r + masterColor.g + masterColor.b > 5 && (
        <div
          className="pointer-events-none fixed inset-0 transition-all duration-700 opacity-20"
          style={{
            background: `radial-gradient(circle at 50% 45%, rgba(${masterColor.r}, ${masterColor.g}, ${masterColor.b}, 0.35) 0%, rgba(${masterColor.r}, ${masterColor.g}, ${masterColor.b}, 0.08) 45%, rgba(0,0,0,0) 70%)`,
            filter: 'blur(90px)',
          }}
        />
      )}

      {/* 1. Header Superior con Selector Slim de Algoritmos */}
      <div ref={headerRef} className="w-full z-30">
        <Header />
      </div>

      {/* 2. Escenario Central: Pantalla con Esquinas y Nodos Clickeables */}
      <main
        ref={screenContainerRef}
        className="relative flex-1 flex flex-col items-center justify-center w-full px-4 py-2 z-20"
      >
        <VirtualScreen />
      </main>

      {/* 3. Dock Ultra Slim en la Parte Inferior */}
      <div ref={bottomBarRef} className="w-full z-40">
        <SlimBottomBar />
      </div>

      {/* 4. Modal Configuración de Punto Específico / Asignación de Luz */}
      <PointConfigModal />

      {/* 5. Modal Administrador Multi-Luces WiZ */}
      <LightManagerModal />

      {/* 6. Popover Ajuste Fino de Parámetros */}
      <TunePopover />
    </div>
  );
};

export const App: React.FC = () => {
  return (
    <AmbilightProvider>
      <AmbilightStudio />
    </AmbilightProvider>
  );
};

export default App;
